import { START_NEW_EXAM, SET_EXAM_READY, APP_SYNCED } from '../actions';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  submitted: false,
  loading: false,
  exam: {},
  examReady: false
  /*bicamsNo: '',
  examNo: '',
  currentAge: '',
  yearsOfEducation: '',
  diagnosis: '',
  diagnosisSubtype: '',
  yearsOfDiagnosis: '',
  countryOfExam: '',
  languageOfExam: '',
  examNorms: ''*/
};

export default function exams(state = initialState, action = {}) {
  switch(action.type) {
    case START_NEW_EXAM:
      return {
        submitted: !isEmpty(action.exam),
        loading: true,
        exam: action.exam,
        examReady: true
      };
        
        /*bicamsNo: action.ParticipantBicamsNumber,
        examNo: action.ExamNumber,
        currentAge: action.Age,
        diagnosis: action.Diagnosis
        yearsOfEducation: '',
        diagnosis: '',
        diagnosisSubtype: '',
        yearsOfDiagnosis: '',
        countryOfExam: '',
        languageOfExam: '',
        examNorms: ''*/
     

    case APP_SYNCED:
      return {
        appSynced: !isEmpty(action.exam),
        exam: action.exam,
        examReady: true
      };

    case SET_EXAM_READY:
      return {
        examReady: true
      };
      
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/exams.js